import { configureStore } from "@reduxjs/toolkit"
import { creaEventoReducer } from './creaEvento'
import { creaArtistaReducer } from './artista'

export default configureStore({
    reducer: {
        creaEvento: creaEventoReducer,
        creaArtista: creaArtistaReducer
    }
})